/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Mortgage_PreapprovedInputs */

const cs_enum_mortgage_preapproved = /** @type {(inputs: Enum_Mortgage_PreapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hypotéka schválena`)
};

const en_enum_mortgage_preapproved = /** @type {(inputs: Enum_Mortgage_PreapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mortgage pre-approved`)
};

/**
* | output |
* | --- |
* | "Mortgage pre-approved" |
*
* @param {Enum_Mortgage_PreapprovedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_mortgage_preapproved = /** @type {((inputs?: Enum_Mortgage_PreapprovedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Mortgage_PreapprovedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_mortgage_preapproved(inputs)
	return cs_enum_mortgage_preapproved(inputs)
});